<template>
  <main>
    <NavMenu>
      <NavItem name="个人中心" />
      <NavItem name="我的书单" path="/MyBookList" />
      <NavItem name="查看书单" active />
    </NavMenu>
    <MyBookListItem :item="detail" class="info" :isLink="false" isDetail>
      <template slot="buttons">
        <el-button type="primary" @click="editItem(detail)">编辑书单</el-button>
        <el-button type="plain" @click="confirmDeleteBookList(detail.id)">
          删除书单
        </el-button>
      </template>
    </MyBookListItem>
    <section v-loading="loading">
      <p class="count">
        共
        <span>{{ count }}</span>
        条记录
      </p>
      <div class="list-top">
        <SortButtons :sortFilters="orderActions" @change-sort="changeSort" />
        <SearchInput @do-search="doSearch" :haveOption="false" />
      </div>
      <NoContent class="empty" v-if="emptyList" />
      <ul v-else>
        <li v-for="(item, index) in bookList" :key="item.ruid">
          <p>{{ index + 1 + page.pageno * page.pagesize }}</p>
          <div class="list-item">
            <BookTemplate :book="item" @getList="getList" class="template" isFavorite />
            <div class="buttons">
              <el-button type="plain" @click="cancelFavorite(item)">取消收藏</el-button>
            </div>
          </div>
        </li>
        <ListPager :total="count" :page="page" @change-page="changePage" />
      </ul>
    </section>
    <el-dialog title="编辑书单" :close-on-click-modal="false" :visible.sync="showDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item label="书单名称：" prop="name">
          <el-input
            v-model.trim="ruleForm.name"
            maxlength="30"
            show-word-limit
            placeholder="请输入书单名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="学术标签：" prop="tag">
          <el-input
            v-model="ruleForm.tag"
            placeholder="请输入学术标签，多个请以英文分号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="书单简介：" prop="description">
          <el-input
            type="textarea"
            rows="6"
            maxlength="200"
            show-word-limit
            v-model.trim="ruleForm.description"
            placeholder="请输入书单简介"
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item class="actions">
          <div class="flex-end">
            <el-button type="plain" @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="validateForm('ruleForm')">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </main>
</template>

<script>
import SortButtons from 'components/SortButtons'
import SearchInput from 'components/SearchInput'
import NoContent from 'components/NoContent'
import ListPager from 'components/ListPager'
import BookTemplate from 'components/BookTemplate.vue'
import MyBookListItem from './MyBookListItem.vue'

export default {
  name: 'MyRecommendation',
  components: {
    SortButtons,
    SearchInput,
    NoContent,
    ListPager,
    BookTemplate,
    MyBookListItem,
  },
  props: {},
  data() {
    return {
      count: 0,
      orderActions: [],
      bookList: [],
      pageNo: 0,
      pageSize: 5,
      order: {},
      page: { pageno: 0, pagesize: 5 },
      filter: {
        logicalop: 'and',
        relationop: 'like',
        fieldname:
          '10100001,10110001,10120001,15900011,10400001,281450001,888000009,888000001',
        word: '',
      },
      detail: {},
      loading: false,
      showDialog: false,
      ruleForm: {},
      rules: {
        name: [{ required: true, message: '请输入书单名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入书单简介', trigger: 'blur' }],
      },
    }
  },
  computed: {
    emptyList() {
      const list = this.bookList
      return list.length < 1 ? true : false
    },
  },
  methods: {
    async deleteBookList(id) {
      const res = await this.$http.get(`/api/v1/favorite/delete?id=${id}`)
      if (res.cxajaxrc !== 0) return false
      this.$message.success('删除成功')
      setTimeout(() => {
        this.$router.push('/MyBookList')
      }, 500)
    },
    confirmDeleteBookList(id) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => this.deleteBookList(id))
        .catch(() => false)
    },
    editItem(item) {
      const formData = this.lodash.cloneDeep(item)
      if (formData.tag) formData.tag = formData.tag.join(';')
      this.ruleForm = formData
      this.editing = true
      this.showDialog = true
    },
    closeDialog() {
      this.$refs.ruleForm.resetFields()
      this.showDialog = false
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.submitForm()
      })
    },
    async submitForm() {
      let body = this.lodash.cloneDeep(this.ruleForm)
      if (body.tag) body.tag = body.tag.split(';')
      const res = await this.$http.post('/api/v1/favorite/save', body)
      if (res.cxajaxrc != 0) return false
      this.$message.success('保存成功')
      this.closeDialog()
      this.getDetail()
    },
    async deleteFavorite(item) {
      const url = this.lodash.get(item, 'actions[0].url')
      const res = await this.$http.get(url)
      if (res.cxajaxrc !== 0) return false
      this.$message.success('取消收藏成功')
      if (this.$methods.isLastItem(this.page.pageno, this.bookList)) this.page.pageno--
      this.getList()
    },
    cancelFavorite(item) {
      this.$confirm('确定要取消收藏吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteFavorite(item)
        })
        .catch(() => {
          return false
        })
    },
    async getDetail() {
      const id = this.$route.query.id
      const res = await this.$http.get(`/api/v1/favorite/get?id=${id}`)
      this.detail = res.returnvalue
    },
    changeSort(obj) {
      this.order = obj
      this.page.pageno = 0
      this.getList()
    },
    changePage(page) {
      this.page.pageno = page
      this.getList()
    },
    doSearch(obj) {
      this.filter.word = obj.value
      this.page.pageno = 0
      this.getList()
    },
    async getList() {
      try {
        this.loading = true
        const queryString = this.$qs.stringify({
          favoriteid: this.$route.query.id,
          ...this.order,
          pageno: this.page.pageno,
          pagesize: this.page.pagesize,
        })
        const res = await this.$http.post(
          `/api/v1/datasearch/user_center_my_booklist_datalist?${queryString}`,
          { filter: [this.filter] }
        )
        const value = res.returnvalue
        this.bookList = value.recordlist
        this.count = value.recordcount
        this.orderActions = value.orderactions
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getDetail()
    this.getList()
  },
  activated() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
main {
  width: 1200px;
  padding-bottom: 30px;
  align-self: center;
}
.info {
  margin-bottom: 10px;
  padding: 20px;
  box-shadow: $mainShadow;
}
section {
  display: block;
  padding: 20px;
  box-shadow: $mainShadow;
  .count {
    padding: 25px 20px;
    background: #f7f7f7;
    font-size: 16px;
    color: #666;
    span {
      margin: 0 3px;
      color: #f00;
    }
  }
  .list-top {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  ul,
  .empty {
    margin-top: 20px;
    padding: 0;
    list-style: none;
  }
  li {
    display: flex;
    padding: 20px 0;
    border-bottom: 1px dashed #e6e6e6;
    &:first-of-type {
      padding-top: 0;
    }
    > p {
      margin-right: 30px;
      color: #333;
    }
    .list-item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .template {
        flex: 1;
      }
    }
  }
}
</style>
